import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { FinishSignupBanner } from "@/components/FinishSignupBanner";

export const PublicNav = () => {
  const { user } = useAuth();
  return (
  <header className="sticky top-0 z-30 backdrop-blur-xl bg-mm-bg/80 border-b" style={{ background: "color-mix(in srgb, var(--mm-bg) 80%, transparent)" }}>
    <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
      <Link to="/landing" className="flex items-center gap-2" data-testid="public-nav-logo">
        <div className="w-9 h-9 rounded-xl mm-gradient flex items-center justify-center">🧠</div>
        <span className="font-display font-bold text-lg">Mindful Me</span>
      </Link>
      <nav className="flex items-center gap-1 sm:gap-4 text-sm font-medium">
        <Link to="/tools" className="px-1 sm:px-0 whitespace-nowrap text-mm-muted hover:text-mm-text transition-colors" data-testid="public-nav-tools">Free tools</Link>
        <Link to="/articles" className="hidden sm:inline text-mm-muted hover:text-mm-text transition-colors" data-testid="public-nav-articles">Articles</Link>
        <Link to="/pricing" className="hidden sm:inline text-mm-muted hover:text-mm-text transition-colors" data-testid="public-nav-pricing">Pricing</Link>
        <Link to="/about" className="px-2 sm:px-0 text-mm-muted hover:text-mm-text transition-colors" data-testid="public-nav-about">About</Link>
        <Link to="/contact-us" className="hidden sm:inline text-mm-muted hover:text-mm-text transition-colors" data-testid="public-nav-contact">Contact</Link>
        {user ? (
          <Link to="/" className="mm-btn-ghost !py-2 !px-4" data-testid="public-nav-app">Open app</Link>
        ) : (
          <Link to="/login" className="mm-btn-ghost !py-2 !px-4 whitespace-nowrap" data-testid="public-nav-login">Log in</Link>
        )}
      </nav>
    </div>
  </header>
  );
};

export const PublicFooter = () => (
  <footer className="border-t mt-20">
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10 flex flex-col sm:flex-row gap-4 justify-between text-sm text-mm-muted">
      <div>© {new Date().getFullYear()} Mindful Me. Not a substitute for professional care. In crisis? Call or text 988.</div>
      <div className="flex flex-wrap gap-x-5 gap-y-2">
        <Link to="/tools" data-testid="footer-tools">Free calm tools</Link>
        <Link to="/embed" data-testid="footer-embed">Breathing widget</Link>
        <Link to="/wellbeing-check" data-testid="footer-wellbeing">Wellbeing check</Link>
        <Link to="/articles" data-testid="footer-articles">Articles</Link>
        <Link to="/about" data-testid="footer-about">About</Link>
        <Link to="/pricing" data-testid="footer-pricing">Pricing</Link>
        <Link to="/contact-us" data-testid="footer-contact">Contact</Link>
        <Link to="/privacy-promise" data-testid="footer-privacy-promise">Privacy promise</Link>
        <Link to="/legal" data-testid="footer-legal">Legal</Link>
      </div>
    </div>
  </footer>
);

export const PublicLayout = ({ children }) => {
  return (
  <div className="min-h-screen mm-grain">
    <PublicNav />
    <main className="relative z-10">{children}</main>
    <PublicFooter />
    <FinishSignupBanner />
  </div>
  );
};
